import { useQuery } from '@tanstack/react-query';

import { channelDashboardApi, type MetricsRange } from '../services/channelDashboardApi';

export const useChannelMetrics = (channelId: string | undefined, range: MetricsRange, enabled = true) =>
  useQuery({
    queryKey: ['channel-dashboard', channelId, 'metrics', range],
    queryFn: () => channelDashboardApi.getMetrics(channelId!, range),
    enabled: !!channelId && enabled,
    staleTime: 60_000,
  });
